import React, { FC, useState } from 'react';
import { Button, Modal, Table } from 'antd';
import { TFunction } from 'i18next';
import ExportDBLogsModal from './organization-db-logs-export-modal';
import { OrganizationDatabaseStatusItem, CsvKeys } from 'src/stores/organizations-store';

const DatabaseCheckResultsModal: FC<{
  data: { organizationId: String; displayName: string; isSuccess: boolean; error: string }[];
  state: any;
  navigate: any;
  t: TFunction;
  logId: string;
  exportItems: OrganizationDatabaseStatusItem[];
  exportKeys: {
    key: CsvKeys;
    translatedHeader: string;
  }[];
}> = ({ data, t, state, exportItems, navigate, exportKeys, logId }) => {
  const [exportModalVisible, setExportModalVisible] = useState(false);

  return (
    <>
      <h3 className="figma-modal__title">
        <>{t('DatabaseCheckResultsModalTitle')}</>
        <Button
          type="primary"
          style={{ width: '100px', float: 'right', margin: '20px' }}
          onClick={() => {
            setExportModalVisible(true);
          }}
        >
          <>{t('Export')}</>
        </Button>
      </h3>
      <Table
        scroll={{ y: 480 }}
        key={'organizationId'}
        dataSource={data}
        pagination={{ defaultPageSize: 10, responsive: true }}
        columns={[
          {
            title: <>{t('DisplayName')}</>,
            render: (data) => {
              return (
                <span
                  className="clickable-span"
                  onClick={() => {
                    Modal.destroyAll();
                    navigate(`/organizations/${data.organizationId}`, { state });
                  }}
                >
                  {data.displayName}
                </span>
              );
            },
          },
          {
            title: <>{t('CheckDatabaseResult')}</>,
            width: '35%',
            render: (data) => (
              <span style={{ color: data.isSuccess ? '#53c273' : 'red' }}>{data.isSuccess ? `${t('Success')}` : `${t('Error')}: ${data.error}`}</span>
            ),
          },
        ]}
      ></Table>
      {exportModalVisible && (
        <>
          <ExportDBLogsModal
            t={t}
            logId={logId}
            onClose={() => setExportModalVisible(false)}
            items={exportItems}
            keys={exportKeys}
            onExport={() => {
              setExportModalVisible(false);
            }}
          />
        </>
      )}
    </>
  );
};

export default DatabaseCheckResultsModal;
